import { render } from "./RegisterPrest.vue?vue&type=template&id=4ad1f2d3&scoped=true"
import script from "./RegisterPrest.vue?vue&type=script&lang=js"
export * from "./RegisterPrest.vue?vue&type=script&lang=js"

import "./RegisterPrest.vue?vue&type=style&index=0&id=4ad1f2d3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad1f2d3"]])

export default __exports__